import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/templates/')({
  beforeLoad: () => {
    throw redirect({ to: '/explore', search: { tab: 'templates' }, replace: true })
  },
})
